import React, { ComponentType, CSSProperties } from 'react';

const defaultProps = {
  color: '#f0f3f9' as CSSProperties['color'],
  enabled: true,
  size: 50 as CSSProperties['width'],
  style: {} as CSSProperties,
};
const normalizeSize = (size: CSSProperties['width']) => (
    size !== undefined ?
  parseFloat(size !== undefined ? size.toString() : "120").toString() === size.toString()
    ? `${size}px`
    : size.toString() : 
    parseFloat(120 !== undefined ? "120" : "120").toString() === "120"
    ? `${size}px`
    : "120"
);

export type SpinnersProps = Partial<typeof defaultProps>;

export const withSharedProps = <P extends SpinnersProps>(Component: ComponentType<P>) => {
  const Wrapper = (props: P) => {
    const {
      color, enabled, size, style, ...otherProps
    } = props;
    const componentProps = {
      ...otherProps,
      style: {
        color,
        overflow: 'visible',
        width: normalizeSize(size),
        ...style,
      },
    };

    if (!enabled) return null;

    return <Component {...componentProps as P} />;
  };

  Wrapper.defaultProps = defaultProps;

  return Wrapper;
};